export const siteName = "78动漫";

export const navLinks = [
  { label: "首页", href: "#top", active: true },
  { label: "新番情报", href: "#feed", active: false },
  { label: "作品评测", href: "#reviews", active: false },
  { label: "热度榜单", href: "#ranking", active: false },
  { label: "专题企划", href: "#topics", active: false },
];

export const tickerItems = [
  { time: "10:32", text: "《星轨协奏》官宣制作第三季，首支 PV 同步解禁" },
  { time: "09:50", text: "《静水花开》剧场版内地定档 11 月 21 日" },
  { time: "08:15", text: "声优花泽凛确认加盟《夜航西飞》主役阵容" },
  { time: "昨日", text: "《终末行纪》世界观设定集正式上线，含未公开分镜" },
  { time: "昨日", text: "2026 秋番片单出炉，本季值得关注的 12 部作品盘点" },
];

export const heroFeature = {
  kicker: "本期封面故事",
  tag: "深度访谈",
  title: "《琉璃之城》导演专访：用 24 帧讲述一场关于记忆的告别",
  deck: "从第一版分镜草图到最终成片，这部口碑新番走过了三年。我们与导演聊了聊那些被删掉的镜头、坚持保留的长镜头，以及他为什么执意把结局留给观众自己判断。",
  author: "文 / 林晚舟",
  date: "2026 年 10 月 9 日",
  readTime: "阅读约 8 分钟",
  image:
    "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20illustration%20of%20a%20lone%20girl%20with%20silver%20braided%20hair%20standing%20on%20a%20floating%20crystal%20platform%20above%20a%20sea%20of%20clouds%20at%20golden%20sunset%2C%20wearing%20a%20flowing%20deep%20red%20coat%2C%20dramatic%20warm%20orange%20and%20amber%20palette%2C%20painterly%20cel-shaded%20style%2C%20clean%20soft%20cream%20sky%20background%20with%20subtle%20grain%2C%20editorial%20magazine%20cover%20composition%2C%20high%20detail%2C%20cinematic&width=900&height=1200&seq=hero-cover-78anime-01&orientation=portrait",
  alt: "《琉璃之城》动画主视觉插画",
};

export const featureArticles = [
  {
    id: "f1",
    no: "01",
    tag: "新番情报",
    title: "《终末行纪》第一集先行图公开，世界观设定集同步上线",
    excerpt: "官方一次性放出六张先行图与完整世界观时间线，制作组表示本作会以“公路片”节奏推进。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sprawling%20ruined%20city%20with%20vines%20and%20lanterns%20under%20a%20warm%20amber%20dusk%20sky%2C%20tiny%20silhouetted%20travelers%20walking%20a%20stone%20bridge%2C%20muted%20red%20and%20gold%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20hazy%20background%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a1&orientation=landscape",
    alt: "《终末行纪》废墟城市氛围插画",
    meta: "2026.10.09 · 情报",
  },
  {
    id: "f2",
    no: "02",
    tag: "作品评测",
    title: "《白塔之下》：一部被低估的成长系群像动画",
    excerpt: "它没有炫技的打斗，却把“普通人的选择”拍得足够动人。本篇从群像调度与留白手法切入。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20quiet%20coastal%20town%20with%20a%20red%20torii%20gate%20and%20turquoise%20sea%20waves%20at%20sunrise%2C%20a%20student%20in%20navy%20uniform%20on%20a%20wooden%20pier%2C%20warm%20cream%20light%2C%20cel-shaded%20painterly%20style%2C%20soft%20clean%20background%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a2&orientation=landscape",
    alt: "《白塔之下》海边小镇插画",
    meta: "2026.10.08 · 评测",
  },
  {
    id: "f3",
    no: "03",
    tag: "趣味杂谈",
    title: "深夜食堂番为什么总能治愈人？我们统计了 30 部作品",
    excerpt: "从暖光色调到进食音效，那些让你不自觉放松下来的细节，其实是精心设计好的。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20cozy%20ramen%20shop%20interior%20glowing%20with%20warm%20lanterns%20at%20night%2C%20steam%20rising%2C%20an%20orange%20cat%20sleeping%20on%20the%20counter%2C%20inviting%20gold%20and%20crimson%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20background%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a3&orientation=landscape",
    alt: "深夜食堂动画场景插画",
    meta: "2026.10.07 · 杂谈",
  },
  {
    id: "f4",
    no: "04",
    tag: "情报速报",
    title: "《流星观测班》新视觉公布，故事将迎来舞台转换",
    excerpt: "官方预告下半季会离开校园，把镜头交给屋顶之上的城市夜空。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20friends%20on%20a%20rooftop%20watching%20a%20meteor%20shower%20over%20a%20sleeping%20city%2C%20deep%20crimson%20and%20amber%20sky%2C%20warm%20sparkles%2C%20cel-shaded%20painterly%20style%2C%20clean%20soft%20background%20with%20stardust%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a4&orientation=landscape",
    alt: "《流星观测班》屋顶观星插画",
    meta: "2026.10.06 · 速报",
  },
  {
    id: "f5",
    no: "05",
    tag: "新番情报",
    title: "《琥珀之刃》定档十月，骑士题材的又一次正面对决",
    excerpt: "制作方公布的战斗分镜比想象中更克制，主打的是“动作之外的情绪重量”。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20young%20knight%20holding%20a%20glowing%20amber%20sword%20in%20a%20sunlit%20forest%20clearing%2C%20floating%20golden%20pollen%2C%20warm%20green%20and%20gold%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20misty%20background%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a5&orientation=landscape",
    alt: "《琥珀之刃》骑士森林插画",
    meta: "2026.10.05 · 情报",
  },
  {
    id: "f6",
    no: "06",
    tag: "作品评测",
    title: "《纸飞机与向日葵》第一印象：把日常拍出了呼吸感",
    excerpt: "第一集几乎没有冲突，却用声音与光影留住了观众。这种冒险值得肯定。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20school%20rooftop%20garden%20with%20sunflowers%20and%20a%20paper%20airplane%20flying%20over%20a%20warm%20afternoon%20sky%2C%20gentle%20cream%20clouds%2C%20cel-shaded%20painterly%20style%2C%20clean%20soft%20background%2C%20editorial%20wide%20composition%2C%20high%20detail&width=800&height=500&seq=feed-78anime-a6&orientation=landscape",
    alt: "《纸飞机与向日葵》屋顶花园插画",
    meta: "2026.10.04 · 评测",
  },
];

export const rankingWeek = [
  {
    rank: 1,
    title: "琉璃之城",
    subtitle: "记忆与告别",
    heat: 98.6,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20silver-haired%20girl%20holding%20a%20glowing%20amber%20crystal%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-01&orientation=squarish",
    alt: "《琉璃之城》缩略图",
  },
  {
    rank: 2,
    title: "星轨协奏",
    subtitle: "青春与合奏",
    heat: 95.2,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20boy%20conductor%20with%20an%20amber%20baton%20and%20floating%20music%20notes%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-02&orientation=squarish",
    alt: "《星轨协奏》缩略图",
  },
  {
    rank: 3,
    title: "终末行纪",
    subtitle: "末日公路",
    heat: 92.8,
    trend: "same",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20traveler%20with%20a%20red%20scarf%20standing%20on%20a%20cliff%20at%20dusk%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-03&orientation=squarish",
    alt: "《终末行纪》缩略图",
  },
  {
    rank: 4,
    title: "白塔之下",
    subtitle: "成长群像",
    heat: 88.4,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20girl%20in%20a%20white%20uniform%20standing%20before%20a%20tall%20foggy%20tower%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-04&orientation=squarish",
    alt: "《白塔之下》缩略图",
  },
  {
    rank: 5,
    title: "潮汐之城",
    subtitle: "海与音乐",
    heat: 85.1,
    trend: "down",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20girl%20with%20teal%20hair%20standing%20in%20warm%20ocean%20light%2C%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-05&orientation=squarish",
    alt: "《潮汐之城》缩略图",
  },
  {
    rank: 6,
    title: "银河食堂",
    subtitle: "治愈日常",
    heat: 81.7,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20cheerful%20chef%20girl%20holding%20a%20steaming%20bowl%20inside%20a%20cozy%20galaxy%20diner%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-06&orientation=squarish",
    alt: "《银河食堂》缩略图",
  },
];

export const rankingNew = [
  {
    rank: 1,
    title: "琥珀之刃",
    subtitle: "骑士 · 新作",
    heat: 96.4,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20young%20knight%20holding%20a%20glowing%20amber%20sword%20in%20forest%20light%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-07&orientation=squarish",
    alt: "《琥珀之刃》缩略图",
  },
  {
    rank: 2,
    title: "纸飞机与向日葵",
    subtitle: "日常 · 新作",
    heat: 93.1,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20schoolgirl%20holding%20a%20paper%20airplane%20in%20a%20sunflower%20field%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-08&orientation=squarish",
    alt: "《纸飞机与向日葵》缩略图",
  },
  {
    rank: 3,
    title: "夜航西飞",
    subtitle: "航空 · 新作",
    heat: 90.5,
    trend: "same",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20pilot%20girl%20standing%20beside%20a%20vintage%20airplane%20at%20sunset%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-09&orientation=squarish",
    alt: "《夜航西飞》缩略图",
  },
  {
    rank: 4,
    title: "静水花开",
    subtitle: "剧情 · 新作",
    heat: 87.2,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20girl%20in%20a%20warm%20kimono%20beside%20a%20quiet%20pond%20with%20floating%20flowers%2C%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-10&orientation=squarish",
    alt: "《静水花开》缩略图",
  },
  {
    rank: 5,
    title: "箱庭之子",
    subtitle: "悬疑 · 新作",
    heat: 84.6,
    trend: "down",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20boy%20holding%20a%20tiny%20glowing%20lamp%20inside%20a%20miniature%20wooden%20town%2C%20warm%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-11&orientation=squarish",
    alt: "《箱庭之子》缩略图",
  },
  {
    rank: 6,
    title: "棱镜旅团",
    subtitle: "冒险 · 新作",
    heat: 80.9,
    trend: "up",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20portrait%20of%20a%20girl%20wizard%20holding%20a%20glowing%20prismatic%20staff%20on%20a%20warm%20hilltop%2C%20cream%20background%2C%20cel-shaded%20painterly%20style%2C%20square%20thumbnail%20composition%2C%20high%20detail&width=240&height=240&seq=rank-78anime-12&orientation=squarish",
    alt: "《棱镜旅团》缩略图",
  },
];

export const reviews = [
  {
    id: "r1",
    score: "9.1",
    tag: "成长 · 群像",
    title: "《白塔之下》第七集：把沉默拍成了最大的声音",
    excerpt:
      "整集没有一句台词，却用门缝的光、楼梯的回声和一个迟迟没有落下的手，完成了主角真正的成长。这可能是本季最好的单集。",
    verdict: "推荐补番",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20tall%20white%20tower%20rising%20above%20a%20foggy%20town%20with%20tiny%20lantern%20lights%2C%20a%20boy%20looking%20up%20wearing%20a%20scarf%2C%20muted%20cream%20and%20sage%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20misty%20background%2C%20editorial%20composition%2C%20high%20detail&width=800&height=560&seq=review-78anime-01&orientation=landscape",
    alt: "《白塔之下》第七集氛围插画",
  },
  {
    id: "r2",
    score: "8.6",
    tag: "悬疑 · 叙事",
    title: "《箱庭之子》第一印象：用一座微缩城市讲人的孤独",
    excerpt:
      "把整座城市装进一个房间，是这部作品最大胆的设定。它克制地不解释，反而让那种被困住的感觉更真实。",
    verdict: "值得追更",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20miniature%20box%20town%20on%20a%20wooden%20desk%20where%20a%20girl%20reaches%20toward%20paper%20stars%2C%20warm%20lamp%20glow%2C%20cream%20and%20amber%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20soft%20background%2C%20editorial%20composition%2C%20high%20detail&width=800&height=560&seq=review-78anime-02&orientation=landscape",
    alt: "《箱庭之子》微缩城市插画",
  },
];

export const topics = [
  {
    no: "专题 01",
    title: "2026 秋番追番指南",
    desc: "按题材与更新节奏整理的本季片单，附每日更新表。",
    count: "12 部作品 · 更新中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20an%20autumn%20anime%20season%20lineup%20collage%20with%20falling%20maple%20leaves%20and%20warm%20lantern%20light%2C%20cream%20and%20vermillion%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20background%2C%20vertical%20magazine%20poster%20composition%2C%20high%20detail&width=700&height=900&seq=topic-78anime-01&orientation=portrait",
    alt: "2026 秋番追番指南专题封面",
  },
  {
    no: "专题 02",
    title: "声优专访专栏",
    desc: "走进录音棚，听配音演员聊角色与声音的取舍。",
    count: "8 位嘉宾 · 已完结",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20voice%20actor%20recording%20booth%20with%20warm%20studio%20lighting%20and%20floating%20sound%20waves%2C%20cream%20and%20gold%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20background%2C%20vertical%20magazine%20poster%20composition%2C%20high%20detail&width=700&height=900&seq=topic-78anime-02&orientation=portrait",
    alt: "声优专访专栏封面",
  },
  {
    no: "专题 03",
    title: "动画配乐精选",
    desc: "编辑部私藏的原创原声带清单，适合深夜播放。",
    count: "24 首曲目 · 更新中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20oversized%20headphones%20resting%20on%20piano%20keys%20with%20floating%20musical%20notes%20and%20warm%20sparkles%2C%20cream%20and%20amber%20palette%2C%20cel-shaded%20painterly%20style%2C%20clean%20background%2C%20vertical%20magazine%20poster%20composition%2C%20high%20detail&width=700&height=900&seq=topic-78anime-03&orientation=portrait",
    alt: "动画配乐精选专题封面",
  },
];

export const genres = [
  "热血",
  "日常",
  "恋爱",
  "科幻",
  "悬疑",
  "治愈",
  "竞技",
  "奇幻",
  "国创",
  "剧场版",
];

export const footerColumns = [
  {
    title: "内容板块",
    links: ["新番情报", "作品评测", "情报速报", "热度榜单", "专题企划"],
  },
  {
    title: "关于 78 动漫",
    links: ["编辑部介绍", "投稿与合作", "内容准则", "隐私政策", "意见反馈"],
  },
  {
    title: "关注渠道",
    links: ["订阅周报", "官方社群", "内容更新日志", "联系邮箱"],
  },
];